import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
	providedIn: 'root'
})
export class BankService {
	private url = environment.api;
	constructor(
		private http: HttpClient,
	) { }

	/**
	   * Function that sends an HTTP GET request to the api in order to retrieve information about the banks of the user.
	   * @returns An observable object that represents the HTTP GET request, that includes the list of the banks
	   */
	getBanks() {
		return this.http.get(this.url + "api/bank/all");
	}

	getAdvances() {
		return this.http.get(this.url + "api/erp/bank/advancesi/-1");
	}

	getAdvancesClient(clientId: number) {
		return this.http.get(this.url + "api/erp/bank/advancesi/" + clientId);
	}

	getAdvancesUpPay() {
		return this.http.get(this.url + "api/erp/bank/advances/-1");
	}

	orecipe(requestBody) {
		return this.http.post(this.url + "api/erp/bank/orecipe",requestBody);
	}

	irecipe(requestBody) {
		return this.http.post(this.url + "api/erp/bank/irecipe",requestBody);
	}

	correlativeCashRecipe() {
		return this.http.get(this.url + "api/erp/bank/correlative-cash-recipe");
	}

	getAdvanceDetails(sourceType: any, documentId: any) {
		return this.http.get(this.url + `api/erp/bank/all-advance-details/${sourceType}/${documentId}`);
	}

}
